import { render, staticRenderFns } from "./CreateVideoList.vue?vue&type=template&id=403c6165&scoped=true&"
import script from "./CreateVideoList.vue?vue&type=script&lang=js&"
export * from "./CreateVideoList.vue?vue&type=script&lang=js&"
import style0 from "./CreateVideoList.vue?vue&type=style&index=0&id=403c6165&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403c6165",
  null
  
)

/* custom blocks */
import block0 from "./CreateVideoList.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports